import React, { useState } from 'react';
import { firestore, auth } from '../firebase/firebase';
import '../assets/css/AddUser.css'; // Import custom styles for AddUser

const AddUser = () => {
  const [displayName, setDisplayName] = useState('');
  const [department, setDepartment] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [permissions, setPermissions] = useState([]);
  const [error, setError] = useState('');

  const handlePermissionsChange = (e) => {
    const selectedPermissions = Array.from(e.target.selectedOptions, (option) => option.value);
    setPermissions(selectedPermissions);
  };

  const handleSignUp = async (e) => {
    e.preventDefault();

    try {
      // Create user account with email and password
      const userCredential = await auth.createUserWithEmailAndPassword(email, password);

      // Access the newly created user's details
      const newUser = userCredential.user;

      // Update user profile with display name
      await newUser.updateProfile({
        displayName: displayName
      });

      // Store user details in Firestore including permissions
      await firestore.collection('NewAdminUsers').doc(newUser.uid).set({
        displayName,
        department,
        email,
        permissions
      });

      // Clear form fields after successful signup
      setDisplayName('');
      setDepartment('');
      setEmail('');
      setPassword('');
      setPermissions([]);
      setError('');

      alert('User created successfully!');
    } catch (error) {
      console.error('Error creating user:', error);
      setError('Failed to create user. ' + error.message);
    }
  };

  return (
    <div className="add-user-container">
      <h2>Create New User</h2>
      <form className="add-user-form" onSubmit={handleSignUp}>
        <label>Name (Display Name):</label>
        <input
          type="text"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          required
        />

        <label>Department:</label>
        <input
          type="text"
          value={department}
          onChange={(e) => setDepartment(e.target.value)}
          required
        />

        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        <label>Password:</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />

        <label>Permissions:</label>
        <select
          multiple
          value={permissions}
          onChange={handlePermissionsChange}
          required
        >
          <option value="Almighty">Almighty</option>
          <option value="SchoolAdmin">School Admin</option>
          <option value="Schools">Schools</option>
        </select>

        <button type="submit">Create User</button>

        {error && <p className="error-message">{error}</p>}
      </form>
    </div>
  );
};

export default AddUser;
